import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Box } from '@weave-mui/material';
import { Tabs, Tab } from '@mui/material';
import CreateJobTab from './data-fix/CreateJobTab';
import CreateScanJobTab from './data-fix/CreateScanJobTab';
import JobStatusTab from './data-fix/JobStatusTab';
import DbRefreshHistoryTab from './data-fix/DbRefreshHistoryTab';
import CollectionRecordsTab from './data-fix/CollectionRecordsTab';
const TABS = [
    { id: 'create-job', label: 'Create Job' },
    { id: 'job-status', label: 'Job Status' },
    { id: 'db-refresh-history', label: 'DB Refresh History' },
    { id: 'collection-records', label: 'Collection Records' },
    { id: 'rollback-scan', label: 'Rollback Scan' },
];
const DataFix = () => {
    const [activeTab, setActiveTab] = useState('create-job');
    return (_jsxs(Box, { children: [_jsx(Tabs, { value: activeTab, onChange: (_, v) => setActiveTab(v), sx: { borderBottom: 1, borderColor: 'divider', mb: 0 }, children: TABS.map((tab) => (_jsx(Tab, { label: tab.label, value: tab.id }, tab.id))) }), activeTab === 'create-job' && _jsx(CreateJobTab, {}), activeTab === 'job-status' && _jsx(JobStatusTab, {}), activeTab === 'db-refresh-history' && _jsx(DbRefreshHistoryTab, {}), activeTab === 'collection-records' && _jsx(CollectionRecordsTab, {}), activeTab === 'rollback-scan' && _jsx(CreateScanJobTab, {})] }));
};
export default DataFix;
